<!-- CEM-1 CEM-3 FR-1 22F 订单信息 -->
<template>
  <div class="information">
    <div class="information__title">
      <i class="information__linker"></i>
      PCB
    </div>
    <div class="information__container">
      <InformationTop :data="topData" />
      <InformationList :list="list">
        <!-- 阻焊颜色 -->
        <div slot="color" class="information__color">
          <ColorBlock :color="data.color" />
          <span :style="colors[data.color]" class="information__color__text">
            {{ data.color }}
          </span>
          (字符：{{ data.charcolor }})
        </div>
      </InformationList>
      <InformationList :list="buttonList">
        <!-- 确认生产稿 -->
        <div slot="review_file" class="information__review_file">
          {{ { 0: '无需', 1: '需要(超时系统自动确认)', 2: '需要(不允许自动确认)' }[data.review_file] }}
        </div>
        <!-- 订单支付方式 -->
        <div slot="deduct_type" class="information__deduct_type">
          <span class="tips">{{ { 1: '自动扣款并确认', 2: '手动确认支付' }[data.deduct_type] }}</span>
          <template v-if="data.deduct_type == 1">
            (正负相差不超过<i>￥{{ data.deduct_limit }}</i>)
          </template>
        </div>
      </InformationList>
    </div>
  </div>
</template>

<script>
import InformationTop from './top'
import InformationList from './list'
import ColorBlock from '@@/components/colorBlock/index'

import { COLORS } from '@@/utils/constant'
import { getLabels } from '@@/utils/getFields'
import { fieldsFormat } from './fieldsFormat'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    InformationTop,
    InformationList,
    ColorBlock
  },
  data() {
    return {
      boardTypes: ['FR-4', 'ROGERS', 'CEM-1'],
      colors: COLORS,
    }
  },
  computed: {
    labels() {
      return getLabels(this.boardTypes)
    },
    fieldsFormat() {
      return fieldsFormat('CEM-1', this.data)
    },
    topData() {
      const { units, bcount = 0, layoutx = 0, layouty = 0, deltime, standard_deltime, area, weight } = this.data
      return {
        left: units == 1 ? { label: '生产数量', value: bcount ? `${bcount} Pcs` : '--' } : { label: '生产数量', value: bcount ? `${bcount} Set` : '--', tips: `(${layoutx * layouty * bcount} Pcs)` },
        right: [
          { label: '生产周期', value: standard_deltime || deltime || '--' },
          { label: '面积', value: area ? `${(area / 10000).toFixed(4)}㎡` : '--' },
          { label: '重量(预估)', value: weight ? `${weight}kg` : '--' },
        ]
      }
    },
    list() {
      const list = [
        { width: '195px', children: ['board_type', 'blayer', 'pbnum'] },
        { width: '220px', children: ['units', 'length', 'layout', 'sidewidth'] },
        { width: '220px', children: ['bheight', 'copper', 'lineweight', 'vias'] },
        { width: '300px', children: ['color', 'spray', 'forming_method', 'routing_profile_tolerance'] },
        { children: ['carbon_oil', 'circuit_patterning_process'] },
      ]
      return list.map(this.format)
    },
    buttonList() {
      const list = [
        { width: '195px', children: ['user_stamp', 'cross_board'] },
        { width: '220px', children: ['test', 'paper'] },
        { width: '295px', children: ['report', 'report_type'] },
        { children: ['review_file', 'deduct_type'] }
      ]
      return list.map(this.format)
    }
  },
  methods: {
    format(item) {
      const { labels, data, fieldsFormat } = this
      item.children = item.children.map(key => ({
        label: labels[key], 
        value: key in fieldsFormat ? (fieldsFormat[key] || '----') : data[key] || '----',
        slot: fieldsFormat[key] === 'slot' ? key : false
      }))
      return item
    },
  }
}
</script>

<style lang="scss" scoped>
@import '~@@/styles/mixin.scss';
.information {
  display: flex;
  padding: 0 15px 12px;

  .information__title {
    flex-shrink: 0;
    position: relative;
    box-sizing: border-box;
    margin-right: 5px;
    width: 40px;
    height: 40px;
    line-height: 38px;
    text-align: center;
    font-weight: 700;
    color: $--form-color-base;
    border-radius: $--border-radius-base;
    border: 1px solid $--form-color-base;
    background-color: $--input-background-color;
    .information__linker {
      @include moduleLinkerMixin(22px, horizontal, dark);
      position: absolute;
      top: -4px;
      right: -4px;
    }
  }
  .information__container {
    flex: 1;
    >div {
      & + div {
        margin-top: 2px;
      }
    }
  }
  .information__btn {
    margin-top: 5px;
    text-align: center;
  }

  .information__color {
    .information__color__text {
      color: var(--color);
    }
  }
  .information__review_file {
    color: $--color-warning;
  }
  .information__deduct_type {
    .tips {
      color: $--color-warning;
    }
    >i {
      color: $--color-primary;
    }
  }
  .information__reinforce {
    .information__reinforce__handler {
      display: block;
      width: 100px;
      @include ellipsis
    }
  }
}
</style>